import EventsService from '../../helpers/eventsService'
import Controllers from './Controllers'

const getPlayers = amount => {
  return Array(amount).fill(0).map(() => 
    new EventsService
  )
}

export {
  Controllers,
  getPlayers,
}
